<!-- eslint-disable -->
<template>

    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="card card-custom gutter-b">
                    <div class="card-header">
                        <div class="card-title">
                            <h3 class="card-label">Основная информация</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <!--begin::Example-->

                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <div v-else class="example mb-10">

                            <div>
                                <label>Изображение профиля</label>

                                <div class="mb-3 mt-3">
                                    <img v-if="user.image" :src="$urlBackEnd(user.image)" class="avatar avatar-lg">
                                </div>

                                <button @click="deleteImage" v-if="user.image" class="btn btn-danger btn-sm mb-4">Удалить изображение</button>

                                <input v-model="user.image"
                                       class="form-control"
                                       :class="{'is-invalid': user.image}"
                                       type="hidden"
                                       id="image"
                                       name="image"
                                       aria-describedby="basic-addon2"
                                       value="">

                                <vue-dropzone ref="myVueDropzone"
                                              id="dropzone"
                                              :options="dropzoneOptions"
                                              :useCustomSlot=true
                                              v-on:vdropzone-success="successDrop"
                                              v-on:vdropzone-max-files-exceeded="maxDrop"
                                >
                                    <div class="dropzone-custom-content">
                                        <b class="dropzone-custom-title">Выберите файл</b>
                                        <div class="subtitle">...или перетащите его сюда</div>
                                    </div>
                                </vue-dropzone>




                                <b-form-group class="mt-5" description="Введите имя пользователя" label="Имя:">
                                    <b-form-input
                                            v-model.trim="user.name"
                                            :class="{'is-invalid': errors.name}"
                                            placeholder="Введите имя"
                                    ></b-form-input>
                                    <div v-if="errors.name" class="invalid-feedback">{{errors.name[0]}}</div>
                                </b-form-group>


                                <div class="form-group mb-2">
                                    <b-form-group class="mb-2" description="Введите email" label="Email:">
                                        <b-form-input autocomplete="off" v-model.trim="user.email" :class="{'is-invalid': errors.email}" required></b-form-input>
                                        <div v-if="errors.email" class="invalid-feedback">{{errors.email[0]}}</div>
                                    </b-form-group>
                                </div>


                                <div class="card card-custom card-stretch gutter-b">

                                    <!--begin::Header-->
                                    <div class="card-header border-0 py-5">
                                        <h3 class="card-title align-items-start flex-column">
                                            <span class="card-label font-weight-bolder text-dark">Роли</span>
                                            <span class="text-muted mt-3 font-weight-bold font-size-sm">
                    Роли пользователей определяют права доступа к функционалу сайта</span>
                                        </h3>
                                    </div>
                                    <!--end::Header-->
                                    <div class="card-body pt-0 pb-3">
                                        <div class="row align-items-center mb-10">
                                            <div class="col-lg-12 col-xl-12">
                                                <div class="row align-items-center">
                                                    <div class="col-md-6 my-2 my-md-0">
                                                        <b-form-select
                                                                class="mb-2 mr-sm-2 mb-sm-0"
                                                                :value="null"
                                                                v-model="add_role"
                                                        >
                                                            <option :value="null">Выберите роль</option>
                                                            <template v-for="(role, i) in roles" >
                                                                <option v-bind:key="i"
                                                                        :value="role"
                                                                        :disabled="disabledRoles(role.id)"
                                                                >{{role.name}}</option>
                                                            </template>
                                                        </b-form-select>
                                                    </div>
                                                    <div class="col-md-6 my-2 my-md-0">
                                                        <b-button @click="addRoleToUser" ref="add_role_user" variant="primary">Добавить роль</b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div v-for="(role, i) in user.roles" class="row align-items-center mb-3 role mx-0">
                                            <div v-bind:key="i" class="col-lg-12 col-xl-12">
                                                <div class="row align-items-center">
                                                    <div class="col-md-6 my-2 my-md-0">
                                                        <h4>{{ role.name }}</h4>
                                                    </div>

                                                    <div class="col-md-6 my-2 my-md-0 text-right">
                                                        <b-button @click="deleteRole(role.id)" size="sm" variant="danger">Удалить</b-button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>



                                    </div>

                                </div>


                                <b-button @click="saveProfile" ref="save_user" type="submit" variant="primary">Сохранить</b-button>

                            </div>
                        </div>
                        <!--end::Example-->
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card card-custom gutter-b">
                    <div class="card-header">
                        <div class="card-title">
                            <h3 class="card-label">Изменить пароль</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <!--begin::Example-->
                        <div class="example mb-10">
                            <div>
                                <b-form-group
                                        id="input-group-2"
                                        description="Введите действующий пароль"
                                        label="Текущий пароль:"
                                        label-for="input-2"
                                >
                                    <b-form-input
                                            id="input-2"
                                            v-model="password.oldPassword"
                                            :class="{'is-invalid': errors.oldPassword}"
                                            required
                                            type="password"
                                    ></b-form-input>
                                    <div v-if="errors.oldPassword" class="invalid-feedback">{{errors.oldPassword[0]}}</div>
                                </b-form-group>

                                <b-form-group
                                        id="input-group-2"
                                        description="Введите новый пароль"
                                        label="Новый пароль:"
                                        label-for="input-3"
                                >
                                    <b-form-input
                                            id="input-3"
                                            v-model="password.newPassword"
                                            :class="{'is-invalid': errors.newPassword}"
                                            required
                                            type="password"
                                    ></b-form-input>
                                    <div v-if="errors.newPassword" class="invalid-feedback">{{errors.newPassword[0]}}</div>
                                </b-form-group>

                                <b-form-group
                                        id="input-group-2"
                                        description="Подтвердите пароль"
                                        label="Введите новый пароль еще раз:"
                                        label-for="input-4"
                                >
                                    <b-form-input
                                            id="input-4"
                                            v-model="password.newPasswordConfirmation"
                                            :class="{'is-invalid': errors.newPasswordConfirmation}"
                                            required
                                            type="password"
                                    ></b-form-input>
                                    <div v-if="errors.newPasswordConfirmation" class="invalid-feedback">{{errors.newPasswordConfirmation[0]}}</div>
                                </b-form-group>

                                <b-button @click="changePasswordUser" ref="save_password" type="submit" variant="primary">Изменить пароль</b-button>

                            </div>
                        </div>
                        <!--end::Example-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {
        GET_ROLES,
        GET_USER_DETAILS,
        UPDATE_USER_DETAILS,
        UPDATE_USER_PASSWORD
    } from "../../../core/services/store/users.module";
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    export default {
        name: "EditAccount",
        components: {
            vueDropzone: vue2Dropzone
        },

        mounted(){
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Пользователи", route: "/accounts" },
                { title: "Редактировать пользователя" }
            ]);
            this.$store.dispatch(GET_USER_DETAILS, this.$route.params.id);
            this.$store.dispatch(GET_ROLES)
                .catch(() => {
                    this.showAlert('Ошибка загрузки ролей', 'warning', 'toast');
                });
        },

        computed: {
            ...mapGetters({
                user: 'gettersUserEdit',
                load: 'getUserLoad',
                errors: 'errorsUsers',
                roles: 'gettersRoles'
            })
        },

        data() {
            return {
                password: {
                    oldPassword: '',
                    newPassword: '',
                    newPasswordConfirmation: ''
                },

                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/image/user/image'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 5,
                    maxFiles:1,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },

                add_role: null,
            }
        },

        methods: {
            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            successDrop(file, response) {
                this.$refs.myVueDropzone.removeAllFiles();
                this.user.image = response.original;
            },

            maxDrop() {
                console.log('Не более одного файла')
            },

            deleteImage() {
                this.user.image = null;
            },

            addRoleToUser(){
                if (this.add_role){
                    if (!this.user.roles.find(obj => obj.id === this.add_role.id)){
                        this.user.roles.push(this.add_role);
                        this.add_role = null;
                        this.showAlert('Роль успешно добавлена ', 'success', 'toast');
                    }
                    else {
                        this.showAlert('Ошибка! Такая роль уже добавлена', 'danger', 'toast');
                    }
                } else {
                    this.showAlert('Необходимо выбрать роль', 'warning', 'toast');
                }
            },

            disabledRoles(id){
                if (this.user.roles){
                    if (this.user.roles.find(obj => obj.id === id)){
                        return true
                    }
                }
            },

            deleteRole(id){
                var indexToRoles = this.user.roles.findIndex(obj => obj.id === id);
                this.user.roles.splice(indexToRoles , 1);
                this.showAlert('Роль успешно удалена ', 'success', 'toast');

            },

            saveProfile(){
                const submitButton = this.$refs["save_user"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(UPDATE_USER_DETAILS, {id: this.user.id, user: this.user})
                    .then(() => {
                        this.showAlert('Профиль успешно сохранен', 'success', 'toast');
                        this.$router.push({ name: "Accounts" })
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка сохранения, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    })
            },

            changePasswordUser() {

                const submitButton = this.$refs["save_password"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                const new_password = {
                    oldPassword: this.password.oldPassword,
                    newPassword: this.password.newPassword,
                    newPassword_confirmation: this.password.newPasswordConfirmation,
                };

                this.$store.dispatch(UPDATE_USER_PASSWORD, {id: this.user.id, password: new_password})
                    .then(() => {
                    this.showAlert('Изменения успешно сохранены', 'success', 'toast');
                })
                    .catch((response) => {
                    if (response && response.status === 500) {
                        if (response.data.success === false) {
                            this.showAlert('Неверный пароль', 'danger', 'toast');
                        }
                    } else if (response.status === 422) {
                        this.showAlert('Заполните все поля', 'danger', 'toast');
                    }
                })
                    .finally(() => {
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
                    })
            }

        }
    }
</script>

<style scoped>
    .role{
        background-color: #f3f6f9;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 3px;
    }
</style>